export const SET_APP_STATE = "SET_APP_STATE";
export const SET_DEVICE = "SET_DEVICE";
export const SET_PAGE_SCROLL = "SET_PAGE_SCROLL";
export const SET_KEY_PRESS = "SET_KEY_PRESS";
export const ESCAPE_KEY_PRESSED = "ESCAPE_KEY_PRESSED";

export const LISTEN_TO_KEYS = ["Escape"];

export const NAVBAR_HEIGHT = 50;
